import { render, staticRenderFns } from "./tarif-community-manager.vue?vue&type=template&id=cbc9da8e&"
import script from "./tarif-community-manager.vue?vue&type=script&lang=js&"
export * from "./tarif-community-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports